import KeyNames from '@constants/KeyNames'

export default [
  KeyNames.alt,
  KeyNames.ctrl,
  KeyNames.meta,
  KeyNames.shift,
]
